<button #defaultOriginDialogButtons="voxelOverlayOrigin" voxelOverlayOrigin class="no-visible"></button>

<div class="voxel-col-12" *ngIf="dataLoadFilesError">
    <voxel-alert [type]="CONTENT_BOUNDS?.error_files_notification?.type" light class="voxel-mb-2 voxel-mt-4"
        [icon]="CONTENT_BOUNDS?.error_files_notification?.icon">
        {{this.CONTENT_BOUNDS?.error_files_notification?.text}}
    </voxel-alert>
</div>

<div class="voxel-col-12" *ngIf="dataLoadFilesSuccess">
    <voxel-alert [type]="CONTENT_BOUNDS?.success_files_notification?.type" light class="voxel-mb-2 voxel-mt-4"
        [icon]="CONTENT_BOUNDS?.success_files_notification?.icon">
        {{this.CONTENT_BOUNDS?.success_files_notification?.text}}
    </voxel-alert>
</div>

<div class="card card-search" *ngIf="CONTENT_BOUNDS?.sections?.verify_client; let section">
    <div class="card-content">
        <p>{{section?.title}}</p>

        <form [formGroup]="form" autocomplete="off">

            <div class="voxel-row" *ngIf="this.documentTypeList.length>0">
                <voxel-form-field (click)="onClickChangeFilters('identification')"
                *ngIf="CONTENT_BOUNDS?.sections?.verify_client?.controls?.document_type; let control;"
                class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6 " [label]="control?.label"
                [msgErr]="(getMessageError({label: control?.label, formControlName: (control?.formControlName + '_temp')}, form.get((control?.formControlName + '_temp'))?.errors) | async) || control?.msgErr">
                    <input
                        type="text"
                        voxelInput
                        voxelAutocomplete
                        #includesFilterInputDocument="voxelAutocomplete"
                        [placeholder]="control?.description"
                        [formControlName]="(control?.formControlName + '_temp')"
                    />
                    <app-clean-autocomplete [autocomplete]="documentTypesAutocomplete"></app-clean-autocomplete>
                    <voxel-autocomplete #documentTypesAutocomplete [input]="includesFilterInputDocument" filterMode="includes">
                        <voxel-option *ngFor="let option of documentTypeList" [value]="option.id"  [disabled]="false">
                            {{ option?.name | unicode}}
                        </voxel-option>
                    </voxel-autocomplete>
                </voxel-form-field>               

                <voxel-form-field
                    *ngIf="CONTENT_BOUNDS?.sections?.verify_client?.controls?.document_number; let control;"
                    class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6" [label]="control?.label"
                    [msgErr]="(getMessageError({label: control?.label, formControlName:(control?.formControlName + '_temp')}, form.get((control?.formControlName + '_temp'))?.errors) | async) || control?.msgErr">
                    <input voxelInput [placeholder]="control?.description"
                        [formControlName]="(control?.formControlName + '_temp')" />
                </voxel-form-field>

                <voxel-form-field (click)="onClickChangeFilters('pqr_number')"
                    *ngIf="CONTENT_BOUNDS?.sections?.verify_client?.controls?.pqr_number; let control;"
                    class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6" [label]="control?.label"
                    [msgErr]="(getMessageError({label: control?.label, formControlName:(control?.formControlName)}, form.get((control?.formControlName))?.errors) | async) || control?.msgErr">
                    <input voxelInput [placeholder]="control?.description"
                        [formControlName]="(control?.formControlName)" voxelMask="PQR-00-0999999" shouldKeepMask />
                </voxel-form-field>
            </div>

        </form>

        <div class="actions">
            <div class="voxel-row" *ngIf="CONTENT_BOUNDS?.sections?.verify_client?.controls; let controls">
                <button *ngIf="!isLoading" #originFindClient="voxelOverlayOrigin" voxelOverlayOrigin
                    [disabled]="form.get(controls?.document_type?.formControlName + '_temp')?.invalid || form.get(controls?.document_number?.formControlName + '_temp')?.invalid || form.get(controls?.pqr_number?.formControlName)?.invalid"
                    (click)="findRequestEvent()" voxelButtonContextual
                    class="voxel-col-12 voxel-col-sm-3 voxel-col-md-3">
                    {{this.CONTENT_BOUNDS?.buttons?.verify_client?.caption}}
                </button>

                <voxel-loading-circle *ngIf="isLoading" class="loading voxel-col-12" [loadingTitle]="CONTENT_BOUNDS?.load_text"></voxel-loading-circle>

                <voxel-dialog [dialogOrigin]="defaultOriginDialogButtons" [id]="'dialog-b'"
                    [buttonAlignment]="'horizontal'" [dialogIsOpen]="showDialogConfirm"
                    (dialogClose)="dialogButtonClicked({type:'action1'})">
                    <p>Si desea consultar un nuevo cliente perderá la información ingresada previamente,</p>
                    <p>¿Deseas continuar?</p>
                    <div voxelDialogFooter>
                        <button voxelButtonContextual (click)="dialogButtonClicked({type:'action1'})">
                            Cancelar
                        </button>
                        <button voxelButtonContextual (click)="dialogButtonClicked({type:'action2'})">
                            Aceptar
                        </button>
                    </div>
                </voxel-dialog>

                <voxel-dialog [dialogOrigin]="defaultOriginDialogButtons" [id]="'dialog-b'"
                    [buttonAlignment]="'horizontal'" [dialogIsOpen]="showDialogConfirmFilter"
                    (dialogClose)="dialogButtonClickedFilter({type:'action1'})">
                    <p>Si desea consultar un nuevo cliente perderá la información ingresada previamente,</p>
                    <p>¿Deseas continuar?</p>
                    <div voxelDialogFooter>
                        <button voxelButtonContextual (click)="dialogButtonClickedFilter({type:'action1'})">
                            Cancelar
                        </button>
                        <button voxelButtonContextual (click)="dialogButtonClickedFilter({type:'action2'})">
                            Aceptar
                        </button>
                    </div>
                </voxel-dialog>
            </div>
        </div>

    </div>

</div>

<div class="voxel-col-12" *ngIf="dataError?.value">
    <voxel-alert [type]="CONTENT_BOUNDS?.error_notification?.type" light class="voxel-mb-2"
        [icon]="CONTENT_BOUNDS?.error_notification?.icon">
        {{this.CONTENT_BOUNDS?.error_notification?.text}}
    </voxel-alert>
</div>

<div class="voxel-col-12" *ngIf="dataLoaded?.value && !dataExists?.value">
    <voxel-alert [type]="CONTENT_BOUNDS?.not_found_notification?.type" light class="voxel-mb-2"
        [icon]="CONTENT_BOUNDS?.not_found_notification?.icon">
        {{this.CONTENT_BOUNDS?.not_found_notification?.text}}
    </voxel-alert>
</div>

<ng-container *ngIf="dataLoaded?.value">
    <ng-container *ngIf="CONTENT_BOUNDS?.sections?.verify_client?.controls?.pqr_number; let control;">
        <ng-container *ngIf="!!form.get(control?.formControlName)?.value && !requiredAllFields">
            <ng-container *ngTemplateOutlet="detailTemplate"></ng-container>
        </ng-container>

    </ng-container>

    <ng-container *ngIf="CONTENT_BOUNDS?.sections?.verify_client?.controls?.document_type; let control;">
        <ng-container *ngIf="!!form.get(control?.formControlName)?.value">
            <ng-container *ngTemplateOutlet="identificationTemplate"></ng-container>
        </ng-container>
    </ng-container>
</ng-container>


<ng-template #identificationTemplate>
    <h4>{{this.CONTENT_BOUNDS?.caption_main}}</h4>
    <div id="contactInfo" class="voxel-col-12 card of-auto"
        *ngIf="CONTENT_BOUNDS?.sections?.search_results; let section;">
        <vcl-table>
            <table cdk-table [dataSource]="requestList?.value || []" vclSort (sortData)="sortData($event)">
                <!--<ng-container cdkColumnDef="tipoIdentificacion">
                    <th class="cdk-header-cell cdk-column-position icon-itaufonts_outline_ordenar" cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="tipoIdentificacion"> {{section?.labels?.identificationType}} </th>
                    <td cdk-cell *cdkCellDef="let element"> {{homologarDocumentType(element.tipoIdentificacion) | itemName:"id":"name":documentTypeList | unicode}}</td>
                </ng-container>
                <ng-container cdkColumnDef="nroIdentificacion">
                    <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="numeroIdentificacion"> {{section?.labels?.idenficationNumber}} </th>
                    <td cdk-cell *cdkCellDef="let element"> {{element.numeroIdentificacion}} </td>
                </ng-container>-->
                <ng-container cdkColumnDef="numeroRadicacion">
                    <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="numeroRadicacion" style="max-width: 20% !important;">
                        {{section?.labels?.requestNumber}} </th>
                    <td cdk-cell *cdkCellDef="let element"> {{element.numeroRadicacion}} </td>
                </ng-container>
                <ng-container cdkColumnDef="fechaRadicacion">
                    <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="fechaRadicacion" style="max-width: 10% !important;">
                        {{section?.labels?.requestDate}} </th>
                    <td cdk-cell *cdkCellDef="let element"> {{element.fechaRadicacion | date:"dd-MM-yyyy"}}
                    </td>
                </ng-container>
                <ng-container cdkColumnDef="descripcionSolicitud">
                    <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="descripcionSolicitud" style="max-width: 30% !important;">
                        {{section?.labels?.descriptionRequest}} </th>
                    <td cdk-cell *cdkCellDef="let element"> {{element.descripcionSolicitud}}
                    </td>
                </ng-container>
                <ng-container cdkColumnDef="estadoSolicitud">
                    <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="estadoSolicitud" style="max-width: 20% !important;">
                        {{section?.labels?.requestStatus}} </th>
                    <td cdk-cell *cdkCellDef="let element"> {{element.estadoSolicitud}}
                    </td>
                </ng-container>
                <ng-container cdkColumnDef="fechaCierre">
                    <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="fechaCierre">
                        {{section?.labels?.closingDate}} </th>
                    <td cdk-cell *cdkCellDef="let element"> {{element.fechaCierre | date:"dd-MM-yyyy"}}
                    </td>
                </ng-container>
                <ng-container cdkColumnDef="descripcionCierre">
                    <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="descripcionCierre" style="max-width: 20% !important;">
                        {{section?.labels?.closingDescription}} </th>
                    <td cdk-cell *cdkCellDef="let element"> {{element.descripcionCierre}}
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="causaCierre">
                    <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="causaCierre">
                        {{section?.labels?.closingCause}} </th>
                    <td cdk-cell *cdkCellDef="let element"> {{element.causaCierre}} </td>
                </ng-container>

                <ng-container cdkColumnDef="detalle">
                    <th cdk-header-cell *cdkHeaderCellDef style="max-width: 10% !important;"> {{section?.labels?.actions}} </th>
                    <td cdk-cell *cdkCellDef="let element;">
                        <div class="voxel-row-4 text-center action-icons">
                            <voxel-icon size="L" class="voxel-col-2" (click)="modal(element)" type="secondary"
                                [tooltipText]="section?.labels?.details" voxelTooltip="hover" tooltipType="tip">outros
                            </voxel-icon>                            
                            <voxel-icon  *ngIf="isVisible(element)" size="L" class="voxel-col-2"
                                (click)="onUploadFiles(element)" type="secondary"
                                [tooltipText]="section?.labels?.uploadFiles" voxelTooltip="hover" tooltipType="tip">
                                documentos_pasta_outline
                            </voxel-icon>
                        </div>
                    </td>
                </ng-container>
                <tr cdk-header-row *cdkHeaderRowDef="displayedColumns;"></tr>
                <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>

            </table>
        </vcl-table>
        <div class="voxel-border-small" *ngIf="requestList?.value?.length===0">
            {{this.CONTENT_BOUNDS?.sections?.search_results?.noDataRow}}
        </div>
    </div>

    <vcl-paginator (page)="onPageChange($event)" [length]="requestListResult?.value?.length || 0"
        [pageIndex]="pageIndex" [pageSize]="pageSize" [showPageSelect]="true" language="ES">
    </vcl-paginator>
</ng-template>

<voxel-modal id="modal-a" modalAriaLabelledby="types-modal-title" [modalOrigin]="defaultOriginDialogButtons"
    [modalIsOpen]="modalAShow" [buttonLabels]="{ primary: CONTENT_BOUNDS?.modals?.detail?.button_label }"
    (modalClose)="onCloseModal($event)" *ngIf="CONTENT_BOUNDS">

    <ng-container *ngTemplateOutlet="detailTemplate"></ng-container>

    <div voxelModalFooter>
        <div class="voxel-row">
            <button voxelButton (click)="onCloseModal($event)"
                class="voxel-col-12 voxel-col-offset-xs-2 voxel-col-xs-2 voxel-col-offset-sm-3 voxel-col-sm-4 voxel-col-offset-md-5 voxel-col-md-4">
                {{CONTENT_BOUNDS?.modals?.detail?.button_label}}
            </button>
        </div>
    </div>

</voxel-modal>

<voxel-modal modalAriaLabelledby="upload-files-modal-title" [modalOrigin]="defaultOriginDialogButtons"
    [modalIsOpen]="showModalUploadFiles" [buttonLabels]="{ primary: CONTENT_BOUNDS?.modals?.upload?.button_label }"
    (modalClose)="onCloseModalUploadFiles({action: 0})" *ngIf="CONTENT_BOUNDS">

    <h3 *ngIf="!isLoading" id="types-modal-title">{{CONTENT_BOUNDS?.modals?.upload?.title}}</h3>

    <div class="voxel-col-12 loading-modal text-center" *ngIf="isLoading">
        <voxel-loading-circle class="loading" [loadingTitle]="CONTENT_BOUNDS?.load_text"></voxel-loading-circle>
    </div>

    <app-upload-files *ngIf="!isLoading && configUpload" [config]="configUpload" [fileList]="fileList">
    </app-upload-files>

    <div voxelModalFooter>
        <div class="voxel-row">
            <button [disabled]="formFiles.invalid || isLoading" voxelButton (click)="onCloseModalUploadFiles({action: 1})"
                class="voxel-col-12 voxel-col-offset-xs-2 voxel-col-xs-2 voxel-col-offset-sm-3 voxel-col-sm-4 voxel-col-offset-md-5 voxel-col-md-4">
                {{CONTENT_BOUNDS?.modals?.upload?.button_label}}
            </button>
        </div>
    </div>

</voxel-modal>

<ng-template #detailTemplate>
    <h4 id="types-modal-title" style="font-weight: bold;">{{CONTENT_BOUNDS?.modals?.detail?.title}}</h4>

    <div class="voxel-col-12 loading-modal text-center" *ngIf="isLoading">
        <voxel-loading-circle *ngIf="isLoading" class="loading" [loadingTitle]="CONTENT_BOUNDS?.load_text"></voxel-loading-circle>
    </div>
    <div class="voxel-row search" [formGroup]="form" *ngIf="!isLoading">

        <div id="contactInfoDetail" class="voxel-col-12 results" *ngIf="CONTENT_BOUNDS?.sections?.search_detail; let section;">
            <h5 class="mb-16"><span>{{CONTENT_BOUNDS?.modals?.detail?.caption1}}</span><span style="font-weight: bold;">{{captionSubtitle}}</span><span>{{CONTENT_BOUNDS?.modals?.detail?.caption2}}</span></h5>            
            <ng-container *ngIf="close_cause">
                <div class="voxel-row-4 close-details">
                    <div class="voxel-col-2">
                        <p style="font-weight: bold;">{{CONTENT_BOUNDS?.modals?.detail?.close_subtitle_cause}}</p>
                        <p >{{close_cause}}</p>
                    </div>
                    <div class="voxel-col-2">
                        <p style="font-weight: bold;">{{CONTENT_BOUNDS?.modals?.detail?.close_subtitle_date}}</p>
                        <p >{{close_date| date:"dd-MM-yyyy"}}</p>
                    </div>
                </div>
            </ng-container>
            
            <vcl-table>
                <table cdk-table [dataSource]="requestListDetail?.value || []" vclSort
                    (sortData)="sortDataDetail($event)">
                    <ng-container cdkColumnDef="fecha">
                        <th class="cdk-header-cell cdk-column-position icon-itaufonts_outline_ordenar" cdk-header-cell
                            *cdkHeaderCellDef vclSortColumn columnName="fecha"  style="max-width:10% !important; white-space: normal;"> {{section?.labels?.date}} </th>
                        <td cdk-cell *cdkCellDef="let element" style="max-width:10% !important; white-space: normal;"> {{element.fecha}} </td>
                    </ng-container>
                    <ng-container cdkColumnDef="descripcion">
                        <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="descripcion" style="max-width:10% !important; white-space: normal;">
                            {{section?.labels?.description}} </th>
                        <td cdk-cell *cdkCellDef="let element" style="max-width:10% !important; white-space: normal;"> {{element.descripcion}} </td>
                    </ng-container>
                    <ng-container cdkColumnDef="procesoActual">
                        <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="procesoActual" style="max-width:10% !important; white-space: normal;">
                            {{section?.labels?.ActualProcess}} </th>
                        <td cdk-cell *cdkCellDef="let element" style="max-width:10% !important; white-space: normal;"> {{element.estadoGlobal}} </td>
                    </ng-container>
                    <ng-container cdkColumnDef="estadoActual">
                        <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="estadoActual" style="max-width:30% !important; white-space: normal;">
                            {{section?.labels?.ActualState}} </th>
                        <td cdk-cell *cdkCellDef="let element" style="max-width:30% !important; white-space: normal;"> {{element.estadoNegocio}} </td>
                    </ng-container>

                    <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsDetail;"></tr>
                    <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsDetail"></tr>

                </table>
            </vcl-table>
            <div class="voxel-border-small" *ngIf="requestListDetail?.value?.length===0">
                {{this.CONTENT_BOUNDS?.sections?.search_results?.noDataRow}}
            </div>
        </div>

        <vcl-paginator class="voxel-col-12" (page)="onPageChangeDetail($event)"
            [length]="requestListDetailResult?.value?.length || 0" [pageIndex]="pageIndexDetail" [pageSize]="pageSize"
            [showPageSelect]="true" language="ES">
        </vcl-paginator>
    </div>
</ng-template>
